import React from 'react';
import { motion } from 'framer-motion';
import { Apple, Play } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-32 pb-20 md:pt-48 md:pb-32 overflow-hidden" data-id="element-91">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center" data-id="element-92">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="relative z-10" data-id="element-93">
          <h1 className="text-5xl md:text-7xl font-black tracking-tighter leading-[1.1] mb-6 text-balance" data-id="element-94">
            Your next tattoo,
            <br data-id="element-95" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-500" data-id="element-96">
              designed by AI.
            </span>
          </h1>
          <p className="text-lg md:text-xl text-gray-400 mb-10 max-w-lg text-balance" data-id="element-97">
            Turn your ideas into unique, tattoo-ready art in seconds. Preview
            designs on your skin with AR before you ink.
          </p>

          <div className="flex flex-wrap gap-4" data-id="element-98">
            <a href="https://apps.apple.com/us/app/tatan-ai-tattoo-design-maker/id6763227385" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 bg-white text-black px-6 py-3.5 rounded-2xl font-bold hover:bg-gray-100 transition-transform hover:scale-105 active:scale-95" data-id="element-99">
              <Apple className="w-6 h-6" data-id="element-100" />
              <div className="text-left" data-id="element-101">
                <div className="text-[10px] leading-none text-gray-600 font-semibold mb-0.5" data-id="element-102">
                  Download on the
                </div>
                <div className="text-sm leading-none" data-id="element-103">App Store</div>
              </div>
            </a>
            <div aria-disabled="true" className="flex items-center gap-3 bg-white/5 text-gray-400 px-6 py-3.5 rounded-2xl font-bold border border-white/10 cursor-not-allowed" data-id="element-104">
              <Play className="w-6 h-6" data-id="element-105" />
              <div className="text-left" data-id="element-106">
                <div className="text-[10px] leading-none text-gray-500 font-semibold mb-0.5" data-id="element-107">
                  Google Play
                </div>
                <div className="text-sm leading-none" data-id="element-108">Coming Soon</div>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative lg:ml-auto" data-id="element-109">
          {/* Subtle blue glow halo */}
          <div className="absolute inset-0 bg-tatan-blue/30 blur-[100px] rounded-full transform scale-75" data-id="element-110" />

          <motion.div animate={{
          y: [0, -15, 0]
        }} transition={{
          repeat: Infinity,
          duration: 6,
          ease: 'easeInOut'
        }} className="relative z-10" data-id="element-111">
            <img src="https://cdn.magicpatterns.com/uploads/uyaEaYpfNUYCqLbNvL3xsr/0x0ss_(42).png" alt="TATAN App Interface" className="w-full max-w-[320px] mx-auto md:max-w-[400px] drop-shadow-2xl rounded-[3rem] border-[8px] border-zinc-900" data-id="element-112" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}